import { makeAutoObservable } from 'mobx'
import { auth } from '../firebase'

// What does a user look like????
export const defaultUser = { email: '', displayName: '', password: '' }

class Store {
  user = { ...defaultUser }
  isAuthenticated = false
  loading = true
  listeners = []

  constructor() {
    makeAutoObservable(this)
    this.listenForUser()
  }

  listenForUser = () => {
    const unsubscribeUserAuthState = auth.onAuthStateChanged((user) => {
      this.setUser(user)
    })
    this.listeners.push(unsubscribeUserAuthState)
  }

  setUser = (user) => {
    if (user) {
      this.user = user
      this.isAuthenticated = true
      this.loading = false
      return
    }
    this.loading = false
    this.clearCreds()
  }

  signInWithEmailAndPassword = async (email, pass) => {
    return await auth.signInWithEmailAndPassword(email, pass)
  }

  signOut = async () => {
    return await auth.signOut()
  }

  isUserSignedIn = async () => {
    return !!auth().currentUser
  }

  clearCreds = async () => {
    this.user = { ...defaultUser }
    this.isAuthenticated = false
  }

  register = async (params) => {
    return await auth.createUserWithEmailAndPassword(
      params.email,
      params.password
    )
  }

  getUserName = async() => {
    return await auth().currentUser.displayName
}

 deleteMessage = async(id) => {
  const div = document.getElementById(id);
  if (div) {
    div.parentNode.removeChild(div);
  }
}


  destroy() {
    this.listeners.forEach((listener) => {
      listener()
    })
  }

}

const store = new Store()

export default store

window.store = Store
